import { ConversationSchema, MessageSchema } from 'src/types/chat';
import { generateEntityId } from 'src/utils/chat';
import { ConversationType } from 'src/enums/chat';

export const CONVERSATIONS: ConversationSchema[] = [
    {
        id: 1,
        entityId: generateEntityId(ConversationType.PROJECT, '1234'),
        name: 'conv1',
        projectId: 1234,
        messages: []
    },
    {
        id: 2,
        entityId: generateEntityId(ConversationType.PROJECT, '567'),
        name: 'conv2',
        projectId: 567,
        messages: []
    },
    {
        id: 3,
        entityId: generateEntityId(ConversationType.PROJECT, '789'),
        name: 'conv3',
        projectId: 789,
        messages: []
    },
    {
        id: 4,
        entityId: generateEntityId(ConversationType.PROJECT, '135'),
        name: 'conv4',
        projectId: 135,
        messages: []
    },
    {
        id: 5,
        entityId: generateEntityId(ConversationType.PROJECT, '357'),
        name: 'conv5',
        projectId: 357,
        messages: []
    },
    {
        id: 6,
        entityId: generateEntityId(ConversationType.PROJECT, '790'),
        name: 'conv6',
        projectId: 790,
        messages: []
    }
];

export const FETCH_CONVERSATION_INTERVAL = 30000;
export const DEFAULT_INTERVAL = 10000;
export const ROUND_OFF_SCROLL_HEIGHT = 50;
export const CONVERSATION_PAGE_SIZE = 30;

const mockEntityId = generateEntityId(ConversationType.PROJECT, '2');

export const MOCK_CONVERSATION_MESSAGES: MessageSchema[] = [
    {
        id: 1,
        conversationId: 3,
        entityId: mockEntityId,
        text: 'I have an issue with project 321',
        senderAlias: 'user1',
        timestampEpochMs: 111000,
        isDeleted: false
    },
    {
        id: 2,
        conversationId: 1,
        entityId: mockEntityId,
        text: 'Hello, how are you?',
        timestampEpochMs: 111,
        isDeleted: false,
        senderAlias: 'user1'
    },
    {
        id: 3,
        conversationId: 1,
        entityId: mockEntityId,
        text: 'I am good, thanks! How about you?',
        senderAlias: 'user2',
        timestampEpochMs: 112,
        isDeleted: false,
        replyMessageId: 6
    },
    {
        id: 4,
        conversationId: 1,
        entityId: mockEntityId,
        text: 'Doing well too!',
        senderAlias: 'user1',
        timestampEpochMs: 113,
        isDeleted: false
    },
    {
        id: 5,
        conversationId: 1,
        entityId: mockEntityId,
        text: 'Have you seen the new update?',
        senderAlias: 'user2',
        timestampEpochMs: 114,
        isDeleted: false
    },
    {
        id: 6,
        conversationId: 1,
        entityId: mockEntityId,
        text: 'Yes, it looks great!',
        senderAlias: 'user1',
        timestampEpochMs: 115,
        isDeleted: false,
        replyMessageId: 9
    }
];

export const reactionEmojis = [
    { emoji: '✅', label: 'check' },
    { emoji: '👍', label: 'like' },
    { emoji: '❌', label: 'cross' }
];
